import { ROUTER_PATHS } from "@/shared/constants"
import { Navigate } from "react-router-dom"
import { useUserStore } from "@/entities"
import { ConfirmEmailWidget } from "@/widgets"

export const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { access_token, isEmailConfirmed, isGuest } = useUserStore()

  if (!access_token) {
    return <Navigate to={ROUTER_PATHS.AUTH_LOGIN} replace />
  }

  if (access_token && !isGuest && !isEmailConfirmed) {
    return <ConfirmEmailWidget />
  }

  return <>{children}</>
}
